import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  display: block;\n\n  &:focus {\n    ",
        "\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styled, { useTheme } from "styled-components";
import { Box, Heading, Image, Text, Link } from "@miro-site/core";
var Container = styled(Box).attrs(function(param) {
    var theme = param.theme;
    return {
        $py: theme.header.highlighted.verticalPadding,
        $px: theme.header.highlighted.horizontalPadding,
        $styles: {
            borderRadius: theme.header.highlighted.radius,
            backgroundColor: theme.header.highlighted.background
        }
    };
}).withConfig({
    componentId: "sc-74e47bbb-0"
})(_templateObject());
var ItemContainer = styled(Box).attrs(function(param) {
    var theme = param.theme;
    return {
        $styles: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between"
        }
    };
}).withConfig({
    componentId: "sc-74e47bbb-1"
})(_templateObject1());
var ItemLink = styled(Link).withConfig({
    componentId: "sc-74e47bbb-2"
})(_templateObject2(), function(props) {
    return props.theme.normalizeStyles(props.theme.focus.outlines.withOffset);
});
var Headline = styled(Heading).attrs(function(param) {
    var theme = param.theme;
    return {
        as: theme.header.highlighted.headline.as,
        $mb: theme.header.highlighted.margins.afterHeadline,
        $variant: theme.header.highlighted.headline.variant
    };
}).withConfig({
    componentId: "sc-74e47bbb-3"
})(_templateObject3());
var ViewAllLink = styled(Link).attrs(function(param) {
    var theme = param.theme;
    return {
        $variant: theme.header.highlighted.viewAllLink.variant,
        $color: theme.header.highlighted.viewAllLink.color,
        $size: theme.header.highlighted.viewAllLink.size,
        withArrow: theme.header.highlighted.viewAllLink.withArrow
    };
}).withConfig({
    componentId: "sc-74e47bbb-4"
})(_templateObject4());
var ItemTitle = styled(Text).attrs(function(param) {
    var theme = param.theme;
    return {
        $mb: theme.header.highlighted.margins.afterTitle,
        $variant: theme.header.highlighted.itemTitle.variant
    };
}).withConfig({
    componentId: "sc-74e47bbb-5"
})(_templateObject5());
var ItemDescription = styled(Text).attrs(function(param) {
    var theme = param.theme;
    return {
        $variant: theme.header.highlighted.itemDescription.variant,
        $styles: {
            color: theme.header.highlighted.itemDescription.color
        }
    };
}).withConfig({
    componentId: "sc-74e47bbb-6"
})(_templateObject6());
var Item = function(props) {
    var image = props.image, title = props.title, description = props.description, path = props.path;
    var theme = useTheme();
    return /*#__PURE__*/ _jsx(ItemLink, {
        href: path,
        $mb: theme.header.highlighted.margins.afterItem,
        children: /*#__PURE__*/ _jsxs(ItemContainer, {
            children: [
                /*#__PURE__*/ _jsx(Box, {
                    $mr: theme.header.highlighted.margins.afterImage,
                    $styles: {
                        width: theme.header.highlighted.imageWidth
                    },
                    children: image && /*#__PURE__*/ _jsx(Image, _object_spread({
                        "aria-hidden": true
                    }, image))
                }),
                /*#__PURE__*/ _jsxs(Box, {
                    $styles: {
                        width: theme.header.highlighted.textWidth
                    },
                    children: [
                        /*#__PURE__*/ _jsx(ItemTitle, {
                            children: title
                        }),
                        /*#__PURE__*/ _jsx(ItemDescription, {
                            children: description
                        })
                    ]
                })
            ]
        })
    });
};
var Highlighted = function(props) {
    var title = props.title, items = props.items, showAllLink = props.showAllLink;
    return /*#__PURE__*/ _jsxs(Container, {
        children: [
            /*#__PURE__*/ _jsx(Headline, {
                children: title
            }),
            /*#__PURE__*/ _jsx("ul", {
                children: items.map(function(item) {
                    return /*#__PURE__*/ _jsx("li", {
                        children: /*#__PURE__*/ _jsx(Item, _object_spread({}, item))
                    }, item.title);
                })
            }),
            /*#__PURE__*/ _jsx(ViewAllLink, {
                href: showAllLink.path,
                children: showAllLink.title
            })
        ]
    });
};
export default Object.assign(Highlighted, {
    Item: Item
});
